module.exports = __webpack_public_path__ + "img/bl.11614fc4.svg";